import { render, staticRenderFns } from "./buildingUserManagement.vue?vue&type=template&id=4c91c372&"
import script from "./buildingUserManagement.vue?vue&type=script&lang=js&"
export * from "./buildingUserManagement.vue?vue&type=script&lang=js&"
import style0 from "./buildingUserManagement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports